/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Manage_Copilot_PendingInputs */



/**
* | output |
* | --- |
* | "Copilot ends on {date}." |
*
* @param {Partner_Manage_Copilot_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_copilot_pending = /** @type {((inputs: Partner_Manage_Copilot_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Copilot_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Copilot endet am ${i?.date}.`)
	return /** @type {LocalizedString} */ (`Copilot ends on ${i?.date}.`)
});